import type { Opportunity, OpportunityLifecycle } from 'types'
import type { JourneyAndSalesToLegacyOptions } from 'utils/journeyAndSalesToLegacyOpportunityStatus'
import { journeyAndSalesToLegacyOpportunityStatus } from 'utils/journeyAndSalesToLegacyOpportunityStatus'

/**
 * Maps an Opportunity (opportunities API) to OpportunityLifecycle shape
 * so existing consumers that use snake_case fields keep working.
 * Callers may spread the result with camelCase fields (deliveryModel, gid, etc.)
 * for consumers that use the new shape.
 * Status is always a legacy OpportunityStatus (Phase 2 may pass options.hasAppointment).
 */
export function opportunityToLifecycle(
  opp: Opportunity | null | undefined,
  options?: JourneyAndSalesToLegacyOptions
): OpportunityLifecycle | undefined {
  if (!opp) return undefined

  return {
    closed_date_lost: '',
    created_at: opp.createdAt ?? '',
    customer_gid: opp.customerGid ?? opp.customerSalesforceId ?? '',
    date_confirmation_receipt: '',
    end_of_trial_period: opp.trialEndDate ?? '',
    financial_notes: '',
    fitter_gid: opp.fitterSalesforceId ?? opp.fitterGid ?? '',
    id: opp.id,
    is_closed: '',
    opportunity_gid: opp.salesforceId ?? opp.id ?? '',
    owner_gid: opp.ownerGid ?? opp.ownerSalesforceId ?? '',
    payment_date: '',
    return_date: '',
    status: journeyAndSalesToLegacyOpportunityStatus(opp, options),
    updated_at: opp.updatedAt ?? '',
  }
}
